module.exports = __webpack_public_path__ + "img/biceps.7c4ec214.png";